import ApiService from "./ApiService";

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: `/sign-in`,
    method: "post",
    data,
  });
}
export async function apiGetRouteRoleMap(data) {
  return ApiService.fetchData({
    url: `access-matrix/navigation-roles`,
    method: "get",
    data,
  });
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "/sign-up",
    method: "post",
    data,
  });
}

export async function apiSignOut(data) {
  localStorage.removeItem("token");
  return ApiService.fetchData({
    url: "/user/sign-out",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: "/forgot-password",
    method: "post",
    data,
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/reset-password",
    method: "post",
    data,
  });
}
export async function apiUserResetPassword(params) {
  return ApiService.fetchData({
    url: "/user/reset-password",
    method: "post",
    params,
  });
}
